import React, { useState } from 'react';
import './ProfileEdit.css';

import attach from '../../../Assets/icons/attach.svg';
import defaultAvatar from '../../../Assets/default_avatar.svg';
import Service from "../../../API/Service";

const ProfileEdit = ({ profileData, setProfileData, setIsEditing }) => {
    const [name, setName] = useState(profileData.name);
    const [surname, setSurname] = useState(profileData.surname);
    const [phone, setPhone] = useState(profileData.phone);
    const [avatar, setAvatar] = useState(profileData.photoMetadataLink || defaultAvatar);
    const [error, setError] = useState("");

    const handleSave = async () => {
        if (!name.trim() || !surname.trim() || !phone.trim()) {
            setError("*All fields must be filled.");
            return;
            
          
        }

        
    
        setError("");
    
        try {
            console.log("Отправляем в API:", { 
                name, 
                surname, 
                phone, 
                photoMetadataLink: avatar 
            });

            await Service.updatePersonalData({ 
                name, 
                surname, 
                phone, 
                photoMetadataLink: avatar 
            });
    
            setProfileData({ name, surname, phone, photoMetadataLink: avatar });
            setIsEditing(false);
        } catch (error) {
            console.error("Ошибка при обновлении профиля:", error);
        }
    };
    

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
    
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64Image = reader.result; // Конвертируем в Base64
            setAvatar(base64Image); // Обновляем состояние
        };
        reader.readAsDataURL(file);
    };
    

    const formatPhoneNumber = (value) => {
        let digits = value.replace(/\D/g, ""); // Убираем все нецифровые символы

        if (digits === "") return ""; // Allow empty input

        if (digits.startsWith("8")) {
            digits = "7" + digits.slice(1); // Если начинается с 8, заменяем на 7
        }

        if (!digits.startsWith("7")) {
            digits = "7" + digits; // Если нет 7 в начале, добавляем
        }

        // Ограничение до 11 цифр (без учета "+")
        digits = digits.slice(0, 11);

        // Преобразуем в формат "+7 XXX XXX XX XX"
        if (digits.length <= 1) return "+";
        if (digits.length <= 2) return `+${digits}`;
        if (digits.length <= 5) return `+${digits.slice(0, 1)} ${digits.slice(1)}`;
        if (digits.length <= 8) return `+${digits.slice(0, 1)} ${digits.slice(1, 4)} ${digits.slice(4)}`;
        if (digits.length <= 10) return `+${digits.slice(0, 1)} ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
        return `+${digits.slice(0, 1)} ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9)}`;
    };

    const handlePhoneChange = (e) => {
        setPhone(formatPhoneNumber(e.target.value));
    };

    return (
        <div className="edit-container">
            <div className="avatar-section">
                <img src={avatar} alt="Avatar" className="avatar-image" />
                
               
                <input 
                    type="file" 
                    accept="image/*" 
                    id="avatarUpload" 
                    style={{ display: 'none' }} 
                    onChange={handleImageUpload} 
                />
                
                <label htmlFor="avatarUpload" className="upload-avatar-btn">
                    <img src={attach} alt="Upload icon" /> Upload new Avatar
                </label>
            </div>

            <form className="form">
                <div className="input-container">
                    <label className="label">Name</label>
                    <input 
                        type="text" 
                        value={name} 
                        onChange={(e) => setName(e.target.value)} 
                        className="input-field" 
                        placeholder="Enter your first name"
                    />
                </div>

                <div className="input-container">
                    <label className="label">Surname</label>
                    <input 
                        type="text" 
                        value={surname} 
                        onChange={(e) => setSurname(e.target.value)} 
                        className="input-field" 
                        placeholder="Enter your last name"
                    />
                </div>

                <div className="input-container">
                    <label className="label">Phone Number</label>
                    <input 
                        type="text" 
                        value={phone} 
                        onChange={handlePhoneChange}  
                        className="input-field" 
                        placeholder="Enter your phone number"
                    />
                </div>
                {error && <p className="error-message">{error}</p>} 
            </form>

            <div className="buttons-section">
                <button onClick={() => setIsEditing(false)} className="back-btn">Back</button>
                <button onClick={handleSave} className="save-btn">Save Changes</button>
            </div>
        </div>
    );
};

export default ProfileEdit;
